import { useGetFeatureScanAndPayQuery } from 'generated/sanity-graphql';

export const useFeatureScanAndPay = () => {
  const featureScanAndPayId = 'feature-scan-and-pay';

  const { data, loading } = useGetFeatureScanAndPayQuery({
    variables: {
      featureScanAndPayId,
    },
  });

  return {
    scanAndPayContent: data?.FeatureScanAndPay ?? null,
    loading,
  };
};
